const userTriggers = [
    {
        attributes: {desc: 'user_trigger1', type: 'clusterlet', instance: 'clusterlet', cmdtype: 'set'},
        id: "vEAepuUDZ3dKV1r5roLpVF",
        name: "user_trigger1",
        type: 22
    }
]

export default userTriggers;